import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function TasksProgression(props: Props) {
  return (
    <div className={styles.tasksProgression}>
      <Skeleton className={styles.title} />
      <div className={styles.group}>
        <Skeleton className={styles.percentage} />
        <Skeleton className={styles.hours} />
      </div>
      <Skeleton className={styles.bar} />
    </div>
  );
}

export { TasksProgression };
